/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Seo_Api_Price_SentenceInputs */

const en_seo_api_price_sentence = /** @type {(inputs: Seo_Api_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pricing is in US dollars, ${i?.price}, with no subscription and no monthly minimum.`)
};

const zh_hans1_seo_api_price_sentence = /** @type {(inputs: Seo_Api_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`价格以美元计，${i?.price}，无需订阅，也没有每月最低消费。`)
};

const pt_br2_seo_api_price_sentence = /** @type {(inputs: Seo_Api_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os preços são em dólares, ${i?.price}, sem assinatura e sem mínimo mensal.`)
};

const es_seo_api_price_sentence = /** @type {(inputs: Seo_Api_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los precios están en dólares estadounidenses, ${i?.price}, sin suscripción y sin mínimo mensual.`)
};

const fr_seo_api_price_sentence = /** @type {(inputs: Seo_Api_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le prix est en dollars US, ${i?.price}, sans abonnement et sans minimum mensuel.`)
};

const de_seo_api_price_sentence = /** @type {(inputs: Seo_Api_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Preise sind in US-Dollar, ${i?.price}, ohne Abo und ohne monatliches Minimum.`)
};

const ru_seo_api_price_sentence = /** @type {(inputs: Seo_Api_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Цены в долларах США, ${i?.price}, без подписки и без ежемесячного минимума.`)
};

const it_seo_api_price_sentence = /** @type {(inputs: Seo_Api_Price_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il prezzo è in dollari statunitensi, ${i?.price}, senza abbonamento e senza minimo mensile.`)
};

/**
* | output |
* | --- |
* | "Pricing is in US dollars, {price}, with no subscription and no monthly minimum." |
*
* @param {Seo_Api_Price_SentenceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_api_price_sentence = /** @type {((inputs: Seo_Api_Price_SentenceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Api_Price_SentenceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_api_price_sentence(inputs)
	if (locale === "pt-BR") return pt_br2_seo_api_price_sentence(inputs)
	if (locale === "es") return es_seo_api_price_sentence(inputs)
	if (locale === "fr") return fr_seo_api_price_sentence(inputs)
	if (locale === "de") return de_seo_api_price_sentence(inputs)
	if (locale === "ru") return ru_seo_api_price_sentence(inputs)
	if (locale === "it") return it_seo_api_price_sentence(inputs)
	return en_seo_api_price_sentence(inputs)
});